import { useMemo } from 'react';
import { useLocation } from 'react-router';
import type { AppLayoutItem } from '@/layouts/app/app-layout';
import { useAuthService } from '@/providers/auth-service-provider';
import { useOrganizationService } from '@/providers/organization-service-provider';
import { PATHS } from '@/routes/paths';

export interface AuthorizedLayoutItems {
  headerItems: AppLayoutItem[];
  footerItems: AppLayoutItem[];
}

export function useAuthorizedLayoutItems(): AuthorizedLayoutItems {
  const { isAuthenticated, signOut } = useAuthService();
  const { hasOrganizationContext } = useOrganizationService();
  const { pathname } = useLocation();

  return useMemo(() => {
    const headerItems: AppLayoutItem[] = [];
    const footerItems: AppLayoutItem[] = [];

    if (isAuthenticated && hasOrganizationContext) {
      headerItems.push(
        { type: 'link', label: 'Properties', to: PATHS.properties },
        { type: 'link', label: 'Members', to: PATHS.members },
        { type: 'separator' },
        { type: 'link', label: 'Change company', to: PATHS.selectOrganization },
        { type: 'separator' },
        { type: 'action', label: 'Sign out', onSelect: signOut },
      );
    }

    footerItems.push(
      pathname === PATHS.health
        ? { type: 'link', label: 'Back to app', to: PATHS.root }
        : { type: 'link', label: 'System health', to: PATHS.health },
    );

    if (isAuthenticated) {
      footerItems.push({ type: 'action', label: 'Sign out', onSelect: signOut });
    }

    return { headerItems, footerItems };
  }, [isAuthenticated, hasOrganizationContext, signOut, pathname]);
}
